import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction, Paper, Badge } from '@mui/material';
import {
  Home,
  VideoCall,
  History,
  Person,
  Queue,
  LiveTv,
  CalendarMonth,
} from '@mui/icons-material';
import { useAuthStore } from '../../stores/authStore';
import { useCallStore } from '../../stores/callStore';

export const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuthStore();
  const { queueEntries, activeCalls } = useCallStore();

  // Determinar el valor actual basado en la ruta
  const getCurrentValue = () => {
    const path = location.pathname;
    if (path.includes('/dashboard')) {
      if (path.includes('/patient')) return 0;
      if (path.includes('/employee')) return 0;
      if (path.includes('/family')) return 0;
      return 0;
    }
    if (path.includes('/video-call')) return 1;
    if (path.includes('/calendar') || path.includes('/notifications')) return 2;
    if (path.includes('/history')) return 3;
    if (path.includes('/profile')) return 4;
    return 0;
  };

  const [value, setValue] = React.useState(getCurrentValue());

  React.useEffect(() => {
    setValue(getCurrentValue());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    setValue(newValue);

    switch (newValue) {
      case 0:
        // Navegar al dashboard correspondiente según el rol
        if (user?.role === 'patient') {
          navigate('/dashboard/patient');
        } else if (user?.role === 'employee') {
          navigate('/dashboard/employee');
        } else if (user?.role === 'family') {
          navigate('/dashboard/family');
        } else {
          navigate('/dashboard');
        }
        break;
      case 1:
        // Si hay una llamada activa, navegar a ella
        if (activeCalls.length > 0) {
          navigate(`/video-call/${activeCalls[0].id}`);
        }
        break;
      case 2:
        navigate('/calendar');
        break;
      case 3:
        // Historial (pendiente de implementar)
        break;
      case 4:
        // Perfil (pendiente de implementar)
        break;
      default:
        break;
    }
  };

  // Renderizar navegación diferente según el rol
  if (user?.role === 'patient') {
    return (
      <Paper
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
          display: { xs: 'block', md: 'none' }, // Solo visible en móvil
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
        elevation={8}
      >
        <BottomNavigation value={value} onChange={handleChange} showLabels>
          <BottomNavigationAction label="Inicio" icon={<Home />} />
          <BottomNavigationAction
            label="Llamada"
            icon={
              <Badge badgeContent={activeCalls.length} color="success">
                <VideoCall />
              </Badge>
            }
            disabled={activeCalls.length === 0}
          />
          <BottomNavigationAction label="Calendario" icon={<CalendarMonth />} />
          <BottomNavigationAction label="Perfil" icon={<Person />} />
        </BottomNavigation>
      </Paper>
    );
  }

  if (user?.role === 'employee') {
    return (
      <Paper
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
          display: { xs: 'block', md: 'none' }, // Solo visible en móvil
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
        elevation={8}
      >
        <BottomNavigation value={value} onChange={handleChange} showLabels>
          <BottomNavigationAction
            label="Cola"
            icon={
              <Badge badgeContent={queueEntries.length} color="primary">
                <Queue />
              </Badge>
            }
          />
          <BottomNavigationAction
            label="En Vivo"
            icon={
              <Badge badgeContent={activeCalls.length} color="success">
                <LiveTv />
              </Badge>
            }
          />
          <BottomNavigationAction label="Estadísticas" icon={<History />} />
          <BottomNavigationAction label="Perfil" icon={<Person />} />
        </BottomNavigation>
      </Paper>
    );
  }

  // Para family o cualquier otro rol
  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        display: { xs: 'block', md: 'none' },
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
      elevation={8}
    >
      <BottomNavigation value={value} onChange={handleChange} showLabels>
        <BottomNavigationAction label="Inicio" icon={<Home />} />
        <BottomNavigationAction
          label="Llamadas"
          icon={
            <Badge badgeContent={activeCalls.length} color="success">
              <LiveTv />
            </Badge>
          }
        />
        <BottomNavigationAction label="Grabaciones" icon={<History />} />
        <BottomNavigationAction label="Perfil" icon={<Person />} />
      </BottomNavigation>
    </Paper>
  );
};

export default MobileBottomNav;
